import React, { useState } from 'react'
import PalexLogo from '../../header/PalexLogo'
import ResetForm from './ResetForm'
import { withRouter, useHistory } from 'react-router-dom'
import { usersApi } from '../../../api/usersApi'
import { routes } from '../../../constantes/routes'
import { authApi } from '../../../api/authApi'
import { useDispatch } from 'react-redux'
import { swalAlertError, swalSuccessGeneral } from '../../../utils/swalAlert'
import CloseBtn from '../../buttons/CloseBtn'

const ResetContainer = () => {

    const history = useHistory();

    const [isDisable, setIsDisable] = useState(false)

    const [inputs, setinputs] = useState({
        email: "",
        passCode: "",
        password: "",
        repeatPassword: ""
    })

    const dispatch = useDispatch()
    const logout = () => dispatch(authApi.logout())

    const toLanding = () => {
        history.push(routes.LANDING)
    }

    const toLogin = () => {
        history.push(routes.LOGIN)
    }

    const handleChange = (event) => {
        const value = event.target.value
        const name = event.target.name

        setinputs(inputs => ({ ...inputs, [name]: value }))
    }

    const validateForm = () => {
        return inputs.email.length > 0
            && inputs.passCode.length > 0
            && inputs.password.length > 0
            && inputs.repeatPassword.length > 0
            && inputs.password === inputs.repeatPassword

    }

    const handleSubmit = async (event) => {
        // debugger
        event.preventDefault()
        resetPassword({
            email: inputs.email,
            password: inputs.password,
            passCode: inputs.passCode
        })
    }

    const resetPassword = async (put) => {
        setIsDisable(true)
        try {
            const response = await usersApi.resetPassword(put)
            console.log(response)
            if(response) {
            // if (response.statusText === "OK") {
                swalSuccessGeneral("Se ha restablecido correctamente la contraseña. Vuelva a autentificarse.")
                await logout()
                toLanding()
            }
        } catch (error) {
            console.error("ResetContainer", "resetPassword", error)
            swalAlertError(error.response.data || error.response)
            setIsDisable(false)
        }
    }

    return (
        <>
            <div className="header" style={{ position: "absolute", width: "100%" }}>
                <div className="header__close" onClick={toLogin}>
                    <CloseBtn/>
                </div>
            </div>
              <div className='frameless-login'>
                <div className='login-wrap' style={{}}> 
                    <PalexLogo/>
                    <h2 style={{ margin: 0 }}>Reestablece la contraseña</h2>
                    <ResetForm
                        handleChange={handleChange}
                        handleSubmit={handleSubmit}
                        isDisable={isDisable || !validateForm()}
                        inputs={inputs}
                    />
                </div>
            </div>
        </>
    )
}

export default withRouter(ResetContainer)